export default __webpack_public_path__ + "49f7070cf419386c8888943caccb2442.png";